import { render } from "./newsMainSection.vue?vue&type=template&id=2a8e8135&scoped=true"
import script from "./newsMainSection.vue?vue&type=script&lang=js"
export * from "./newsMainSection.vue?vue&type=script&lang=js"

import "./newsMainSection.vue?vue&type=style&index=0&id=2a8e8135&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8e8135"]])

export default __exports__